import { render, staticRenderFns } from "./RecoveryForgotPasswordForm.vue?vue&type=template&id=cdbb3dfa&scoped=true&"
import script from "./RecoveryForgotPasswordForm.vue?vue&type=script&lang=js&"
export * from "./RecoveryForgotPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbb3dfa",
  null
  
)

export default component.exports